import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { tocSort } from "contexts/toc/tocSort";
import { ITlfItemRelationship, TlfTag } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { TlfItemTableLinkCell } from "../TlfItemTableLinkCell";
import { TlfItemTableTagsCell } from "../TlfItemTableTagsCell";

export const TocHeaders: ISimpleTableField[] = [
  {
    name: "tocNumber",
    label: "Number",
    width: "110px",
    // Sort TOC items by number using custom sort function.
    sortFn: (a, b) => tocSort(a.tocNumber as string, b.tocNumber as string),
    // Search TOC items by number, label, copied-from template ID, or tags.
    searchFn: (row, searchText) => {
      const normalised = searchText.toLowerCase().trim();
      const matchesTextFields =
        (row.tocNumber as string | undefined)?.toLowerCase().includes(normalised) ||
        (row.tocLabel as string | undefined)?.toLowerCase().includes(normalised) ||
        (row.tlfCopiedFromLink as ITlfItemRelationship | undefined)?.azsolId
          ?.toLowerCase()
          .includes(normalised);
      const matchesTags =
        Array.isArray(row.tlfTags) &&
        (row.tlfTags as TlfTag[]).some((tag) => tag.tagValue.toLowerCase().includes(normalised));
      return (matchesTextFields ?? false) || matchesTags;
    },
    canColumnFilter: true,
    renderFn: TlfItemTableLinkCell,
  },
  {
    name: "tlfTagValues",
    label: "Tags",
    width: "200px",
    canColumnFilter: true,
    renderFn: TlfItemTableTagsCell,
  },
  {
    name: "tocLabel",
    label: "Title",
    width: "600px",
    sortFn: simpleTableSortFn,
    canColumnFilter: true,
  },
];
